<template>
  <v-container cols="12" class="d-flex justify-center">
    <v-btn :href="settings.link || '#'" class="lightning-model-page__cta--primary" size="large">
      <span>{{ settings.label }}</span>
      <v-icon>$next</v-icon>
    </v-btn>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  settings: any | undefined
}>()

const cta = computed(() => props.settings ?? {})
const ctaTypography = computed(() => cta.value?.typography ?? {})
const ctaBorder = computed(() => cta.value?.border ?? {})
const ctaIcon = computed(() => cta.value?.icon ?? {})
const ctaFontSize = computed(
  () => `${ctaTypography.value?.fontSize}${ctaTypography.value?.fontSizeUnit}`,
)
const ctaLetterSpacing = computed(
  () => `${ctaTypography.value?.letterSpacing}${ctaTypography.value?.letterSpacingUnit}`,
)
const ctaLineHeight = computed(
  () => `${ctaTypography.value?.lineHeight}${ctaTypography.value?.lineHeightUnit}`,
)
const ctaIconContainerSize = computed(
  () => `${ctaIcon.value?.sizes?.container ?? '30'}${ctaIcon.value?.sizes?.containerUnit ?? 'px'}`,
)
const ctaIconSize = computed(
  () => `${ctaIcon.value?.sizes?.icon ?? '30'}${ctaIcon.value?.sizes?.iconUnit ?? 'px'}`,
)
const ctaBorderStyle = computed(
  () =>
    `${ctaBorder.value?.width ?? '1'}${ctaBorder.value?.widthUnit ?? 'px'} ${ctaBorder.value?.style ?? 'solid'} ${ctaBorder.value?.color}`,
)
const ctaBorderRadius = computed(
  () => `${ctaBorder.value?.radius ?? '0'}${ctaBorder.value?.radiusUnit ?? 'px'}`,
)
</script>

<style scoped>
.lightning-model-page__cta--primary {
  background-color: v-bind('cta?.colors?.background');
  border: v-bind('ctaBorderStyle');
  border-radius: v-bind('ctaBorderRadius');
  color: v-bind('cta?.colors?.color');
  width: 100%;
  max-width: 500px;
  overflow: hidden;
}
.lightning-model-page__cta--primary :deep(.v-btn__content span) {
  font-family: v-bind('cta?.typography?.fontFamily');
  font-size: v-bind('ctaFontSize');
  font-style: v-bind('cta?.typography?.fontStyle');
  font-weight: v-bind('cta?.typography?.fontWeight');
  letter-spacing: v-bind('ctaLetterSpacing');
  text-decoration: v-bind('cta?.typography?.textDecoration');
  text-transform: v-bind('cta?.typography?.textTransform');
  line-height: v-bind('ctaLineHeight');

  transition-property: all;
  transition-duration: 0.28s;
  transition-delay: unset;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.lightning-model-page__cta--primary:hover {
  background-color: v-bind('cta?.colors?.backgroundHover');
  color: v-bind('cta?.colors?.colorHover');
}
.lightning-model-page__cta--primary :deep(.v-icon) {
  background-color: v-bind('cta?.icon?.colors?.background');
  color: v-bind('cta?.icon?.colors?.color');
  height: v-bind('ctaIconContainerSize');
  margin-left: 6px;
  width: v-bind('ctaIconContainerSize');

  transition-property: all;
  transition-duration: 0.28s;
  transition-delay: unset;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.lightning-model-page__cta--primary:hover :deep(.v-icon) {
  background-color: v-bind('cta?.icon?.colors?.backgroundHover');
  color: v-bind('cta?.icon?.colors?.colorHover');
}
.lightning-model-page__cta--primary :deep(.v-icon):before {
  font-size: v-bind('ctaIconSize');
}
</style>
